__turbopack_context__.v({
  "inlineFigureCaption": "mYz5xW_inlineFigureCaption",
  "inlineFigureImage": "mYz5xW_inlineFigureImage",
  "leadIn": "mYz5xW_leadIn",
});
